import React, { FC, useRef } from 'react';
import { Dialog } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import API from 'api/API';
import Button from 'components/Button';
import InputField from 'components/InputField';
import { SetModalButtonContainer, SetModalHeader, SetModalMedium } from 'components/SetModal/SetModal.styles';
import { useLanguage } from 'context/AppContext';

interface CreateModalProps {
  open: boolean;
  close: () => void;
}

const CreateSetModal: FC<CreateModalProps> = ({ open, close }) => {
  const setName = useRef('');
  const navigate = useNavigate();
  const [language] = useLanguage();

  const handleCreate = async (): Promise<void> => {
    try {
      await API.set.load(setName.current);
      close();
      navigate(`/set/${setName.current}/edit`);
    } catch (error) {
      API.errorHandler(error);
    }
  };

  return (
    <Dialog open={open} onClose={close} maxWidth="md">
      <SetModalMedium>
        <SetModalHeader>{language.CreateModal.setCodeTitle}</SetModalHeader>
        <InputField
          variant="outlined"
          fullWidth
          placeholder={language.CreateModal.setCodePlaceholder}
          onChange={e => (setName.current = e.target.value)}
        />
        <SetModalButtonContainer>
          <Button fullWidth onClick={handleCreate}>
            {language.CreateModal.add}
          </Button>
        </SetModalButtonContainer>
      </SetModalMedium>
    </Dialog>
  );
};

export default CreateSetModal;
